const qs = require('qs')
const { showError } = require('../../libs/helper')

module.exports = {
  getData: async (g, params) => {
    const result = g.$http({
      url: `${process.env.VUE_APP_SUBFOLDER_API2}api/sensus-pengguna-b/setup/jenis-ruang/list`,
      method: 'post',
      data: qs.stringify(params),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }).then(res => res.data).catch(err => {
      showError(g, err, 'Error Get Data')
    })
    return result
  },
  submitAdd: async (g, data) => {
    const finalData = {
      ...data,
      username: g.$cookies.get('username'),
    }
    const result = await g.$http({
      url: `${process.env.VUE_APP_SUBFOLDER_API2}api/sensus-pengguna-b/setup/jenis-ruang/create`,
      method: 'post',
      data: qs.stringify(finalData),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }).then(res => res.data).catch(err => {
      showError(g, err, 'Error Submit Form')
    })
    return result
  },
  submitUpdate: async (g, data) => {
    const finalData = {
      ...data,
      username: g.$cookies.get('username'),
    }
    let result
    await g.$http({
      url: `${process.env.VUE_APP_SUBFOLDER_API2}api/sensus-pengguna-b/setup/jenis-ruang/update`,
      method: 'post',
      data: qs.stringify(finalData),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }).then(res => {
      result = res.data
    }).catch(err => {
      result = err
    })
    return result
  },
  getDetail: async (g, params) => {
    const result = g.$http({
      url: `${process.env.VUE_APP_SUBFOLDER_API2}api/sensus-pengguna-b/setup/jenis-ruang/detail`,
      method: 'post',
      data: qs.stringify(params),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }).then(res => res.data).catch(err => {
      console.log(err)
    })
    return result
  },

}
